/** returns info from our current process steps
@return { Array }
*/
export const getProcessSteps = state => {
    return state.processStepsInfo
}

/** returns literary abilities list
@return { Array }
*/
export const getLiteraryAbilities = state => {
    return state.literaryAbilities
}

/** returns maritalStatuses list
@return { Array }
*/
export const getMaritalStatus = state => {
    return state.maritalStatuses
}

/** returns countries list
@return { Array }
*/
export const getCountries = state => {
    return state.countries
}

/** returns provinces list
@return { Array }
*/
export const getProvinces = state => {
    return state.provinces
}

/** returns counties list
@return { Array }
*/
export const getCounties = state => {
    return state.counties
}

/** returns counties list
@return { Array }
*/
export const getProvinceCounties = state => {
    return state.provinceCounties
}

/** returns occupations list
@return { Array }
*/
export const getProcessOccupation = state => {
    return state.processOccupation
}

/** returns professions list
@return { Array }
*/
export const getProfessions = state => {
    return state.professions
}

/** returns professional activities list
@return { Array }
*/
export const getProfessionalActivities = state => {
    return state.professionalActivities
}

/** returns contractual ties list
@return { Array }
*/
export const getContractualTies = state => {
    return state.contractualTies
}

/** returns provinces agencies
@return { Array }
*/
export const getAgenciesProvinces = state => {
    return state.provincesAgencies
}

/** returns branches
@return { Array }
*/
export const getBranches = state => {
    return state.branches
}
